// src/pages/TermIndex.jsx
import React from "react";
import { Link } from "react-router-dom";
import s from "../styles/PolicyIndex.module.css";

const apps = [
  {
    id: "whitenoise",
    name: "White Noise: Calm Sleep",
    path: "/apps/whitenoise/termofuse",
  },
  {
    id: "qrbarcode",
    name: "QR & Barcode Scanner: Fast Reader Pro",
    path: "/apps/qrbarcode/termofuse",
  },
  {
    id: "smartgps",
    name: "Smart gps compass",
    path: "/apps/smartgps/termofuse",
  },
  {
    id: "notespark",
    name: "Note Spark: Ai Note Taker",
    path: "/apps/notespark/termofuse",
  },
  {
    id: "magicerace",
    name: "Magic Eracer: Remove object",
    path: "/apps/magicerace/termofuse",
  },
  {
    id: "seekaichat",
    name: "Seek Ai Chat",
    path: "/apps/seekaichat/termofuse",
  },
  {
    id: "nola",
    name: "Nola AI Chat Friend",
    path: "/apps/nola/termofuse",
  },
  {
    id: "hwsolver",
    name: "Ai Homework Solver",
    path: "/apps/hwsolver/termofuse",
  },
  {
    id: "photo_vaylt",
    name: "Veilify Photo Vault",
    path: "/apps/photo_vaylt/termofuse",
  },
  {
    id: "voice_changer",
    name: "Voice changer pro",
    path: "/apps/voice_changer/termofuse",
  },
  {
    id: "colorie_counter",
    name: "Ai Calorie counter: food tracker",
    path: "/apps/colorie_counter/termofuse",
  },
  {
    id: "invoice_maker",
    name: "Invoice Maker for Contractors",
    path: "/apps/invoice_maker/termofuse",
  },
  {
    id: "smart_spy",
    name: "Smart Spy Detector (MVP)",
    path: "/apps/smart_spy/termofuse",
  },
  {
    id: "collage_ai",
    name: "Smart Collage Ai",
    path: "/apps/collage_ai/termofuse",
  },
  {
    id: "trader_lab",
    name: "Trader Lab",
    path: "/apps/trader_lab/termofuse",
  },
  {
    id: "wishflow",
    name: "WishFlow",
    path: "/apps/wishflow/termofuse",
  },
  {
    id: "brainiq",
    name: "BrainIQ: Boost Your Mind",
    path: "/apps/brainiq/termofuse",
  },
  {
    id: "puretrackervaping",
    name: "PureTracker: Quit Vaping",
    path: "/apps/puretrackervaping/termofuse",
  },
  {
    id: "puretrackerdrinking",
    name: "PureTracker: Quit Drinking",
    path: "/apps/puretrackerdrinking/termofuse",
  },
  {
    id: "pupverse",
    name: "Pupverse: Dog Training",
    path: "/apps/pupverse/termofuse",
  },
  {
    id: "schedula",
    name: "Schedula",
    path: "/apps/schedula/termofuse",
  },
];

export default function TermIndex() {
  return (
    <div className={s.wrapper}>
      <h2>Terms of use</h2>
      <ul className={s.appList}>
        {apps.map((app) => (
          <li key={app.id} className={s.appListItem}>
            <Link to={app.path} className={s.appLink}>
              {app.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
